<template>
  <div class="estate-basic" v-loading="isLoading">
    <el-form label-position="left">
      <el-form-item
        v-for="(item, index) in requiredList"
        :key="index"
        class="auto-height"
      >
        <div class="rules-name">{{ item.displayName }}</div>
        <el-checkbox
          v-model="item.value"
          v-if="
            item.value === true ||
            item.value === false ||
            item.value === 'true' ||
            item.value === 'false'
          "
          >{{ item.displayName }}</el-checkbox
        >
        <el-input
          v-else
          v-model="item.value"
          clearable
          :min="0"
          :placeholder="`请输入${item.displayName}`"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="btn-group">
      <el-button type="primary" @click="changeClaims" :loading="isLoadingSubmit"
        >保存</el-button
      >
      <el-button @click="reduction" :loading="isCloaseLoading">重置</el-button>
    </div>
  </div>
</template>

<script>
import { deepCopy } from "@/utils/deepCopy";
import { estateSettings, updateEstateSettings } from "@/http/api/system";
export default {
  props: {
    isEdit: { type: Boolean },
  },
  data() {
    return {
      requiredSetting: [],
      requiredList: [],
      isDisabled: false,
      permissions: this.$store.getters.permissions,
      isLoadingSubmit: false,
      isCloaseLoading:false,
      isLoading:true
    };
  },
  mounted() {
    this.init();
    // this.isDisabled = !this.permissionList["RocketIdentity.Roles.ManagePermissions"];
  },
  methods: {
    showDisable() {
      if (this.isDisabled) {
        this.$message.warning({
          message: `您暂无修改权限`,
          showClose: true,
        });
      }
    },
    reduction() {
      this.isCloaseLoading = true;
      this.init();
      this.isCloaseLoading = false;
    },
    init() {
      this.isLoading = true
      this.requiredList = [];
      estateSettings().then((res) => {
        res.result.map((item) => {
          if (!item.isCollection) {
            this.requiredList.push(item);
          }
        });
        setTimeout(()=>{
          this.isLoading = false
        },300)
      });
    },
    cancel() {
      this.init();
    },

    changeSelectedScope(val, item) {
      if (this.permissions["System.EstateSettings.Update"]) {
        this.changeClaims(item, val);
      } else {
        this.$message.warning({
          message: `您暂无更新楼盘设置权限`,
          showClose: true,
        });
      }
    },
    changeClaims(setting, selectedScope) {
      this.isLoadingSubmit = true;
      // var data = {
      //   settings: [
      //     {
      //       name: setting.name,
      //       value: setting.value,
      //       isCollection: false,
      //       forceToSet: false,
      //     },
      //   ],
      // };
      let data = [];
      this.requiredList.map((item) => {
        data.push({
          name: item.name,
          value: item.value,
          forceToSet: false,
          isCollection: false,
        });
      });
      let settings = {
          settings: data,
        };
      updateEstateSettings(
        this.$store.getters.generateUpdateSettingsParams,
        settings
      ).then((res) => {
        this.isLoadingSubmit = false;
        this.$message
          .success({
            message: `修改成功`,
            showClose: true,
          })
          .catch((err) => {
            this.isLoadingSubmit = false;
          });
        this.init();
        this.isEditSetting = false;
      });
    },

    submit() {
      this.requiredSetting = deepCopy(this.requiredList);
      //console.log("提交接口");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.estate-basic {
  padding: 20px;
  background: #fff;
  .el-input {
    width: 330px;
  }
}
</style>